import axios from 'axios';
import constants from '../constants';
// import authService from '../auth/AuthService'; // acquire token from getters['oidcStore/oidcAccessToken']
import moment from 'moment';
import { employees } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/employee';

export default {
  getActive () {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/employees` )
        .then( response => {
          resolve( response.data );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  employeesForMyCalendar () {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/employeesForMyCalendar` )
        .then( response => {
          resolve( response.data );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getActiveInPeriod ( startDate, endDate ) {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/employeesByGivenPeriod?fromDate=${moment( startDate ).format( 'YYYY-MM-DD' )}&toDate=${moment( endDate ).format( 'YYYY-MM-DD' )}` )
        .then( response => {
          resolve( response.data );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getReplacements ( region ) {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/replacements/?region=${( region ? region : '' )}` )
        .then( response => {
          resolve( response );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getReplacementsForDate ( date, region ) {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/replacementsForDate/?date=${moment( date ).format( 'YYYY-MM-DD' )}&region=${( region ? region : '' )}` )
        .then( response => {
          resolve( response );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getAllEmployees () {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/getAllEmployees` )
        .then( response => {
          resolve( response );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getEmployees () {
    return new Promise( function ( resolve, reject ) {
      AppUsersClient.get( `${resource}/getEmployees` )
        .then( response => {
          resolve( response.data );
        } )
        .catch( error => {
          reject( error );
        } );
    } );
  },
  getAvailableEmployees: ( forGroup, forDate ) => AppUsersClient.get( `${resource}/getAvailableEmployees/${forGroup}/${moment( forDate ).format( 'YYYY-MM-DD' )}` ),

};